import { useLang } from 'hooks/lang';

import { Row, Column, Card } from 'components/Blocks';
import { PropertyWithIcon } from 'components/PropertyWithIcon';
import {
  AlarmCheckIcon,
  CalendarIcon,
  HandCoinsIcon,
  LocationPinMapIcon,
  UserSquareIcon,
} from 'components/Icons';

import { UserRef } from './UserInput';
import { ProjectTypeInfo } from './ProjectTypeInfo';
import { ProjectCountries } from './Countries';
import { DeviceTarget } from './DeviceTarget';

import { useProjectProfile } from 'pages/Projects/ProjectProfile/context';

import { formatDate } from 'utils/date';
import { formatCurrency } from 'utils/text';

export function Details() {
  const { project } = useProjectProfile();

  const { t } = useLang();

  return (
    <Column gap="6">
      <Card flow="column" className="grid grid-cols-2 gap-4 phone:grid-cols-1">
        <PropertyWithIcon value={project.clientName} name={t('client')} icon={<UserSquareIcon />} />

        <PropertyWithIcon
          value={project.clientOrigin}
          name={t('origin-text')}
          icon={<LocationPinMapIcon />}
          containerClassName="row-start-2"
        />

        <UserRef
          label={t('sales-person')}
          id={project?.salesPerson ? project.salesPerson : ''}
          side="right"
        />
      </Card>

      <Card flow="column">
        <PropertyWithIcon
          value={project.estimatedCompletionWorkingDays}
          name={t('estimated-completion-in-working-days')}
          icon={<AlarmCheckIcon />}
        />

        <DeviceTarget value={project.deviceTarget || ''} />

        {!!project.minFee && (
          <PropertyWithIcon
            value={formatCurrency(project.minFee.value, project.currency)}
            name={t('min-fee')}
            icon={<HandCoinsIcon />}
          />
        )}
      </Card>

      <ProjectTypeInfo project={project} />

      <ProjectCountries countries={project.countries} />

      <hr />

      <Row>
        <UserRef label={t('created-by')} id={project?.createdBy ? project.createdBy : ''} />

        <span className="ml-auto">{formatDate(project.createdAt)}</span>

        <CalendarIcon />
      </Row>
    </Column>
  );
}
